export default __webpack_public_path__ + "static/media/labyrinth.8dfcca7f.jpg";